import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-years-emp-dialog',
  templateUrl: './two-years-emp-dialog.component.html',
  styleUrls: ['./two-years-emp-dialog.component.css']
})
export class TwoYearsEmpDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}